import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/OutstandingGiroReport/APReportOutstandingGiroAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class APReportOutstandingGiroActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/OutstandingGiroReport/APReportOutstandingGiro")
	}

	render() {
		return (
			<Activity 
				name="APReportOutstandingGiro"
				RenderedComponent={this.RenderedComponent}
				context="APReportOutstandingGiro"
				action="APReportOutstandingGiro"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(APReportOutstandingGiroActivity)
